import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { AdminNavigation, EmpNavigation } from "../../../Constants";
import { parseLocalStorageJSON } from "../../../helpers/Localstorage";
import LOCAL_KEYS from "../../../helpers/Localstorage";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
import {
  DashboardRounded,
  PeopleAltRounded,
  WorkRounded,
  AccessTimeRounded,
  AttachMoneyRounded,
  BusinessRounded,
  AssessmentRounded,
  ArticleRounded,
  CalendarMonthRounded,
  KeyboardArrowDownRounded,
  PersonOutlineRounded,
  EventBusyRounded,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { requestGetProfilePicture } from "../../../Redux/ProfileState/ProfileActionCreator";
import Uni_Logo from "../../../Assets/DataCloud.jpeg";
import { setToogleSideNavState } from "../../../Redux/AlertsState/AlertsActionCreator";
import horizantal_logo from "../../../Assets/DataCloud.jpeg";


const LeftNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [collapsed, setCollapsed] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [profileImage, setProfileImage] = useState("/default-cover.jpg");
  const [imageError, setImageError] = useState(false);
  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("dashboard");
  // const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(true);
  const sideNavState = useSelector((state) => state.SideNavReducer);
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 640 : false
  );

  const getProfileImageReducer = useSelector(
    (state) => state.getProfileImageReducer
  );

  const userType = userDetails?.acctType?.toUpperCase() || "USER";
  const Navigation = userType === "ADMIN" ? AdminNavigation : EmpNavigation;

  const iconMap = {
    Dashboard: <DashboardRounded fontSize="small" />,
    Timesheet: <AccessTimeRounded fontSize="small" />,
    "Manage Timesheets": <CalendarMonthRounded fontSize="small" />,
    "Time Off": <EventBusyRounded fontSize="small" />,
    Employee: <PeopleAltRounded fontSize="small" />,
    Invoices: <AttachMoneyRounded fontSize="small" />,
    Client: <BusinessRounded fontSize="small" />,
    Project: <WorkRounded fontSize="small" />,
    Reports: <AssessmentRounded fontSize="small" />,
    Documents: <ArticleRounded fontSize="small" />,
    Profile: <PersonOutlineRounded fontSize="small" />,
  };

  const userMenu = [
    // Removed Logout menu item
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setActiveDropdown(null);
    if (window.innerWidth < 640) {
      setCollapsed(true);
    }
  };

  const handleMainItemClick = (item, isMobile = false) => {
    if (item.children) {
      setActiveDropdown(activeDropdown === item.name ? null : item.name);
    } else {
      handleNavigation(item.href);
      if (isMobile) {
        dispatch(setToogleSideNavState());
      }
    }
  };

  useEffect(() => {
    setActiveDropdown(null);
  }, [location.pathname]);

  useEffect(() => {
    dispatch(requestGetProfilePicture());
  }, []);

  const combinedNavigation = [
    ...Navigation.filter((item) => item.access.includes(userType)),
    ...userMenu.filter((item) => item.access.includes(userType)),
  ];

  const sidebarVariants = {
    expanded: { width: "240px" },
    collapsed: { width: "72px" },
  };

  const mobileSideNav = {
    expanded: { width: "250px" },
    collapsed: { width: "250px" },
  };

  const dividerItems = ["Profile"];

  return (
    <>
      <motion.div
        initial={collapsed ? "collapsed" : "expanded"}
        animate={collapsed ? "collapsed" : "expanded"}
        variants={sidebarVariants}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className={`fixed top-0 left-0 md:sticky md:left-2 z-30 md:z-0 my-2 rounded-2xl bg-white p-3 
        shadow-xl h-[98vh] transition-all duration-300 overflow-y-scroll no-scrollbar
        ${collapsed ? "w-20" : "w-64"} hidden md:block`}
      >
        <div className="flex items-center justify-between border-b border-gray-100 ">
          <div className="flex items-center justify-center pt-2 w-full">
            <div className={`flex items-center w-full justify-center`}>
              <img
                className={`transition-all duration-300 ${collapsed ? 'h-20 w-20 object-contain cursor-pointer' : 'h-24 w-auto object-contain'}`}
                src={collapsed ? Uni_Logo : horizantal_logo}
                alt="Unisoft Logo"
                onClick={() => collapsed && setCollapsed(false)}
              />
            </div>
          </div>
          {!collapsed && (
            <button
              className="p-1 rounded-full hover:bg-gray-100 text-gray-500"
              onClick={() => setCollapsed(!collapsed)}
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
          )}
        </div>

        <div className="flex-5 overflow-y-auto py-4">
          <ul className="space-y-1.5">
            {combinedNavigation.map((item, index) => (
              <React.Fragment key={item.name}>
                {dividerItems.includes(item.name) && (
                  <li className="my-4 border-t border-gray-100"></li>
                )}
                <li>
                  {item.children ? (
                    <div>
                      <button
                        onClick={() => setActiveDropdown(activeDropdown === item.name ? null : item.name)}
                        className={`flex items-center w-full ${
                          collapsed ? "justify-center px-2" : "justify-between px-3"
                        } py-2.5 rounded-lg transition-colors ${
                          location.pathname === item.href ||
                          (item.children &&
                            item.items?.some(
                              (subItem) => subItem.href === location.pathname
                            ))
                            ? "bg-indigo-50 text-indigo-600"
                            : "text-gray-700 hover:bg-gray-50"
                        }`}
                        aria-label={item.name}
                      >
                        <span className="flex items-center">
                          <span className="flex-shrink-0">
                            {iconMap[item.name]}
                          </span>
                          {!collapsed && (
                            <span className="ml-3 text-sm font-medium whitespace-nowrap overflow-hidden">
                              {item.name}
                            </span>
                          )}
                        </span>
                        {!collapsed && item.children && (
                          <KeyboardArrowDownRounded
                            fontSize="small"
                            className={`transition-transform ${
                              activeDropdown === item.name ? "rotate-180" : "rotate-0"
                            }`}
                          />
                        )}
                      </button>

                      {item.children && activeDropdown === item.name && !collapsed && (
                        <div className="mt-1 ml-4 pl-4 border-l border-gray-100">
                          {item.items.map((subItem) => (
                            <Link
                              key={subItem.name}
                              to={subItem.href}
                              className={`flex items-center w-full text-left py-2 pl-2 pr-4 rounded-md text-sm ${
                                location.pathname === subItem.href
                                  ? "text-indigo-600 bg-indigo-50"
                                  : "text-gray-700 hover:bg-gray-50"
                              }`}
                            >
                              {subItem.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      className={`flex items-center w-full ${
                        collapsed ? "justify-center px-2" : "px-3"
                      } py-2.5 rounded-lg transition-colors ${
                        location.pathname === item.href
                          ? "bg-indigo-50 text-indigo-600"
                          : "text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      <span className="flex-shrink-0">
                        {iconMap[item.name]}
                      </span>
                      {!collapsed && (
                        <span className="ml-3 text-sm font-medium whitespace-nowrap overflow-hidden">
                          {item.name}
                        </span>
                      )}
                    </Link>
                  )}
                </li>
              </React.Fragment>
            ))}
          </ul>
        </div>
      </motion.div>

      {/* Mobile Sidebar */}
      <motion.div
        initial={collapsed ? "collapsed" : "expanded"}
        animate={collapsed ? "collapsed" : "expanded"}
        variants={mobileSideNav}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className={`fixed top-0 left-0 z-30 my-2 rounded-2xl bg-white p-3 
        shadow-xl h-[98vh] transition-all duration-300 overflow-y-scroll no-scrollbar
        ${sideNavState.isOpen ? "w-64 translate-x-0" : "w-64 -translate-x-full"} md:hidden`}
      >
        <div className="flex items-center justify-between border-b border-gray-100 pb-3">
          <div className="flex items-center justify-center pt-2">
            <div className="flex items-center justify-start w-full">
              <img
                className="h-16 w-auto"
                src={horizantal_logo}
                alt="Unisoft Logo"
              />
            </div>
          </div>

          <button
            className="p-1 rounded-full hover:bg-gray-100 text-gray-500"
            onClick={() => dispatch(setToogleSideNavState())}
          >
            <ChevronLeftIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto py-4">
          <ul className="space-y-1.5">
            {combinedNavigation.map((item, index) => (
              <React.Fragment key={item.name}>
                {dividerItems.includes(item.name) && (
                  <li className="my-4 border-t border-gray-100"></li>
                )}
                <li>
                  {item.children ? (
                    <div>
                      <button
                        onClick={() => setActiveDropdown(activeDropdown === item.name ? null : item.name)}
                        className={`flex items-center w-full justify-between px-3 py-2.5 rounded-lg transition-colors ${
                          location.pathname === item.href ||
                          (item.children &&
                            item.items?.some(
                              (subItem) => subItem.href === location.pathname
                            ))
                            ? "bg-indigo-50 text-indigo-600"
                            : "text-gray-700 hover:bg-gray-50"
                        }`}
                        aria-label={item.name}
                      >
                        <span className="flex items-center">
                          <span className="flex-shrink-0">
                            {iconMap[item.name]}
                          </span>
                          <span className="ml-3 text-sm font-medium whitespace-nowrap overflow-hidden">
                            {item.name}
                          </span>
                        </span>
                      </button>

                      {item.children && activeDropdown === item.name && (
                        <div className="mt-1 ml-4 pl-4 border-l border-gray-100">
                          {item.items.map((subItem) => (
                            <Link
                              key={subItem.name}
                              to={subItem.href}
                              onClick={() => dispatch(setToogleSideNavState())}
                              className={`flex items-center w-full text-left py-2 pl-2 pr-4 rounded-md text-sm ${
                                location.pathname === subItem.href
                                  ? "text-indigo-600 bg-indigo-50"
                                  : "text-gray-700 hover:bg-gray-50"
                              }`}
                            >
                              {subItem.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      onClick={() => dispatch(setToogleSideNavState())}
                      className={`flex items-center w-full px-3 py-2.5 rounded-lg transition-colors ${
                        location.pathname === item.href
                          ? "bg-indigo-50 text-indigo-600"
                          : "text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      <span className="flex-shrink-0">
                        {iconMap[item.name]}
                      </span>
                      <span className="ml-3 text-sm font-medium whitespace-nowrap overflow-hidden">
                        {item.name}
                      </span>
                    </Link>
                  )}
                </li>
              </React.Fragment>
            ))}
          </ul>
        </div>
      </motion.div>
    </>
  );
};

export default LeftNav;
